import { defineComponent as n, openBlock as r, createBlock as l, unref as c, mergeProps as m, withCtx as p, createElementVNode as t } from "vue";
import { RevIcon as h } from "@ds/components/Icon";
const u = /* @__PURE__ */ n({
  name: "IconBattery",
  __name: "IconBattery",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const o = a;
    return (s, e) => (r(), l(c(h), m(o, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        t("path", { d: "m10.749 5.972-2.812 6.325A.5.5 0 0 0 8.394 13h2.231L9.93 17.864c-.05.345.43.483.571.165l2.812-6.326A.5.5 0 0 0 12.856 11h-2.231l.695-4.864c.05-.345-.43-.483-.571-.164" }, null, -1),
        t("path", { d: "M7.872 8.75H5.125a.75.75 0 0 0-.75.75v5a.75.75 0 0 0 .75.75h3.663l-.214 1.5H5.125a2.25 2.25 0 0 1-2.25-2.25v-5a2.25 2.25 0 0 1 2.25-2.25h3.414l-.667 1.5m4.59 0h3.663a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-.75.75h-2.747l-.667 1.5h3.414a2.25 2.25 0 0 0 2.25-2.25v-5a2.25 2.25 0 0 0-2.25-2.25h-3.45l-.213 1.5m8.548 2.176a1.5 1.5 0 0 1 .115.574v1a1.5 1.5 0 0 1-1.202 1.47c-.162.033-.298-.104-.298-.27v-3.4c0-.166.136-.303.298-.27a1.5 1.5 0 0 1 1.088.896" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
